export const LANG_STORAGE_KEY = 'app_lang';

export type LangCode = 'EN' | 'RU' | 'UZ';

const normalize = (value?: string | null): LangCode | null => {
  if (!value) return null;
  const raw = value.trim();
  if (!raw) return null;
  const primary = raw.split(',')[0].split(';')[0].trim().replace('_', '-');
  const base = primary.split('-')[0].toUpperCase();
  if (base === 'EN' || base === 'RU' || base === 'UZ') return base as LangCode;
  const direct = raw.toUpperCase();
  if (direct === 'EN' || direct === 'RU' || direct === 'UZ') return direct as LangCode;
  return null;
};

export const normalizeLang = (value?: string | null): LangCode => {
  return normalize(value) || 'EN';
};

export const getStoredLanguage = (): LangCode => {
  if (typeof window === 'undefined') return 'EN';
  return normalizeLang(window.localStorage.getItem(LANG_STORAGE_KEY));
};

export const setStoredLanguage = (lang: LangCode) => {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(LANG_STORAGE_KEY, lang);
};

export const toLocaleTag = (lang: LangCode) => {
  if (lang === 'RU') return 'ru';
  if (lang === 'UZ') return 'uz';
  return 'en';
};
